module.exports = __webpack_public_path__ + "@/assets/img/13.3a7faba6.jpg";